import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-ornamental-divider',
  imports: [],
  templateUrl: './ornamental-divider.component.html',
  styleUrl: './ornamental-divider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrnamentalDividerComponent {}
